
import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

export default Vue.extend({
  name: 'TggSelectionCardSkeleton',
  functional: true,
  render(h, { data }) {
    return h(
      'div',
      mergeData(data, {
        staticClass: 'skeleton-element tgg-selection-card-skeleton',
      }),
    )
  },
})
